<template>
  <div class="main-otp">
    <div id="main-otp" class="style-fullWidth otp-background">
      <div class="flex__center">
        <div class="flex-row otp-form">
          <div class="" style="position: relative">
            <img
              src="../../assets/img/eoffice-logo.png"
              alt=""
              class="otp-logo"
            />

            <div class="otp-auth">
              <div class="otp-auth-body">
                <p class="text-center margin-top-10 otp-title margin-bottom-10">
                  Xác thực OTP
                </p>
                <el-form label-position="right">
                  <el-row :gutter="12">
                    <el-col :span="24">
                      <div class="margin-top-10 margin-bottom-10 ">
                        <p class="otp-info">
                          Mã xác thực OTP đã được gửi tới số điện thoại
                          {{ isdnWithMask }}.
                        </p>
                      </div>
                    </el-col>
                  </el-row>
                  <el-row :gutter="12">
                    <el-col :span="24">
                      <p class=" margin-top-10 otp-code">Mã OTP của bạn</p>
                      <el-form-item class="margin-top-15">
                        <el-input
                          v-model="otp"
                          size="medium"
                          class=""
                          placeholder="-"
                          maxlength="6"
                          @input="otpChanged"
                          show-word-limit
                          ref="otpInput"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row :gutter="12">
                    <el-col :span="24">
                      <el-button
                        type="primary"
                        size="large"
                        class="addDocs color__white btn-none__border bg__blue margin-top-15"
                        :plain="true"
                        :disabled="countDown !== 0"
                      >
                        <span
                          class="text-center send-code"
                          v-if="countDown > 0"
                        >
                          Mã OTP sẽ hết hiệu lực trong {{ countDown }} (giây).
                        </span>
                        <span
                          class="text-center send-code"
                          v-if="countDown <= 0"
                          @click="resendOTP"
                        >
                          Gửi lại mã
                        </span>
                      </el-button>
                    </el-col>
                  </el-row>
                </el-form>
                <div class="margin-top-15">
                  <el-button
                    type="text"
                    icon="el-icon-arrow-left"
                    class="back-button"
                    @click="logout"
                  >
                    Đăng nhập với tài khoản khác
                  </el-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <dialog-handler-error
      :openDialog="isOpenDialog"
      :content="content"
      v-if="isEnableDialog"
    ></dialog-handler-error>
  </div>
</template>

<script>
  import DialogHandlerError from "../../components/DialogHandlerError";
  import otpService from "../../services/otpService";
  import utils from "../../services/utils";
  import authenService from "../../services/authenService";
  import h from "../../services/h";
  import errorMessageFilter from "../../filters/errorMessageFilter";
  import userService from "../../services/userService";

  export default {
    name: "otp-page",
    components: {DialogHandlerError},
    data() {
      return {
        otp: "",
        content: null,
        isOpenDialog: false,
        isEnableDialog: false,
        isdnWithMask: null,
        countDown: -1,
        countDownInterval: null,
        users: null,
        timeOut: null,
      };
    },

    watch: {
      isOpenDialog(newValue) {
        newValue && (this.isEnableDialog = newValue);
      }
    },

    created() {
      if (this.isLoggedWithOpt()) {
        this.afterValidateOtp();
      } else {
        this.generateOTP();
        this.loadUser();
      }
    },

    mounted() {
      this.timeOut = setTimeout(() => this.$refs.otpInput.focus());
    },

    destroyed() {
      clearTimeout(this.timeOut);
    },

    methods: {
      isLoggedWithOpt() {
        // return !!authenService.getOtpToken();
        return true;
      },

      resendOTP() {
        return this.generateOTP();
      },

      getMaskOfIsdn(isdn) {
        let isdnWithMask = "";
        let length = isdn.length;
        h.each(
          isdn,
          (char, index) =>
            (isdnWithMask += index <= 2 || index >= length - 3 ? char : "*")
        );
        return isdnWithMask;
      },

      loadUser() {
        return userService.get().then(response => {
          this.users = response.data;
          this.isdnWithMask = this.getMaskOfIsdn(this.users.mobile);
        });
      },

      handleBusinessError(errors) {
        let error = errors[0];
        switch (error.errorCode) {
          case "otp.existAvailableOTP": //nếu người dùng đã được gửi thông tin otp roi > accept mã lỗi này
            this.initCountDown();
            break;
          case "otp.isdnRequired": //neu user không có thông tin số điện thoại
            this.content = errorMessageFilter({errorCode: error.errorCode});
            this.isOpenDialog = true;
            break;
          case "validateOtpService.otpMissMatch":
            this.notify("Lỗi", errorMessageFilter(error), "error", 3000);
            // this.resetOTP();
            break;
          default:
            this.notify("Lỗi", errorMessageFilter(error), "error", 3000);
            break;
        }
      },

      generateOTP() {
        return otpService
          .generateOTP()
          .then(() => {
            this.otp = "";
            this.initCountDown();
          })
          .catch(error => {
            if (utils.isBussinessErrorException(error))
              this.handleBusinessError(error.response.data.errors);
            throw error;
          });
      },

      otpChanged() {
        this.otp = this.otp.trim();
        if (this.otp.length === 6) {
          this.submit();
        }
      },

      submit() {
        otpService
          .validateOTP({otp: this.otp})
          .then(response => (response.data ? response.data.token : null))
          .then(otpToken => authenService.saveOtpToken(otpToken))
          .then(() => this.afterValidateOtp())
          .catch(error => {
            if (utils.isBussinessErrorException(error))
              this.handleBusinessError(error.response.data.errors);
            throw error;
          });
      },

      afterValidateOtp() {
        this.$router.replace({name: "beforeEnterApp"});
      },

      initCountDown() {
        this.countDown = 60;
        this.countDownInterval = setInterval(() => {
          this.countDown--;
          if (this.countDown === 0) {
            clearInterval(this.countDownInterval);
            this.countDownInterval = null;
          }
        }, 1000);
      },

      logout() {
        this.$router.push({name: "logout"});
      }
    }
  };
</script>

<style scoped>
  .otp-logo {
    width: 120px;
    height: 120px;
    position: absolute;
    z-index: 999;
    top: -80px;
    left: calc(50% - 60px);
  }

  .back-button {
    text-align: left;
    padding-left: 0px;
  }
</style>



// WEBPACK FOOTER //
// src/views/login/otp-page.vue